import {Component, OnDestroy, ViewChild} from '@angular/core';
import {
  AuthenticationType,
  FeedbackDialogComponent,
  FeedbackDialogConfigurationInterface,
  ReverseProxyType
} from '@datev/tma-components';
import {environment} from 'projects/environments/environment';
import {Subject, takeUntil} from 'rxjs';
import {ActiveFeedbackService} from '../../shared/services/active-feedback.service';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'dp-layout-download-portal',
  templateUrl: './layout-download-portal.component.html',
  imports: [FeedbackDialogComponent, RouterOutlet],
  host: {
    style: 'display: contents;'
  }
})
export class LayoutDownloadPortalComponent implements OnDestroy {
  private readonly destroySubj = new Subject<undefined>();

  @ViewChild('fdComponent')
  feedbackDialogComponent!: FeedbackDialogComponent;

  feedbackDialogConfiguration: FeedbackDialogConfigurationInterface = {
    featureDisplayName: 'Downloadportal',
    url: environment.activeTMA.surveyUrl,
    probability: environment.activeTMA.probability,
    tmaIdIteration: 0,
  };

  reverseProxyType = LayoutDownloadPortalComponent
    .reverseProxyTypeFromSetting(environment.activeTMA.reverseProxyType);
  authenticationType = AuthenticationType.JWT;

  constructor(private readonly activeFeedbackService: ActiveFeedbackService) {
    this.activeFeedbackService.showDialog$
      .pipe(takeUntil(this.destroySubj))
      .subscribe(() => {
        if (this.feedbackDialogComponent) {
          this.feedbackDialogComponent.startFeedbackDialog();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroySubj.next(undefined);
    this.destroySubj.complete();
  }

  private static reverseProxyTypeFromSetting(typeString: 'local' | 'amr'): ReverseProxyType {
    switch (typeString) {
      case 'local':
        return ReverseProxyType.LOCAL;
      case 'amr':
        return ReverseProxyType.AMR;
      default:
        return ReverseProxyType.NONE;
    }
  }
}
